export const REVALIDATE_TIME = Number(process.env.REVALIDATE_INTERVAL) || 3600
